
import * as type from '../../types/user'

const reducer = (state = [], action) => {
    switch (action.type) {
        case type.FETCH_USER_LIST:
            return action.payload
        default:
            return state
    }
}

export default reducer